// Utility for conditional className merging
// Simple version without external dependencies

export function cn(...classes) {
    return classes
      .filter(Boolean)
      .join(' ')
      .replace(/\s+/g, ' ')
      .trim();
  }